<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="col-lg-3">
        <input type="checkbox" v-model="removeHash" @change="loadLinks" id="removeHash"> <label for="removeHash">Remove hash</label><br>
        <input type="checkbox" v-model="removeEmpty" @change="loadLinks" id="removeEmpty"> <label for="removeEmpty">Remove empty anchors</label><br>
        <input type="checkbox" v-model="removeEmails" @change="loadLinks" id="removeEmails"> <label for="removeEmails">Remove email links</label>
      </div>
    </div>
    <div class="col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Target</th>
          <th>Location</th>
          <th>
            Anchor
            <button class="btn btn-primary btn-xs pull-right" @click="loadLinks(true)"><i class="fa fa-download"></i> CSV</button>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(link, i) in links" :key="i">
          <td>{{ link.link.url }}</td>
          <td>{{ link.post.url }} [{{ link.post.title }}]</td>
          <td>{{ link.link.anchor || '/' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Browser } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      links: [],
      removeHash: false,
      removeEmpty: false,
      removeEmails: false
    }
  },
  computed: {
    ...mapGetters({
      site: 'getPbn'
    })
  },
  mixins: [Browser],
  watch: {
    site () {
      this.loadLinks()
    }
  },
  mounted () {
    this.loadLinks()
  },
  methods: {
    loadLinks (csv = false) {
      axios.get('/pbn/site/' + this.site.punyDomain + '/content/links?type=internal&removeHash=' +
        this.removeHash + '&removeEmpty=' + this.removeEmpty + '&removeEmails=' + this.removeEmails, {
        headers: {
          'Accept': csv === true ? 'text/csv' : 'application/json'
        }
      })
        .then(r => {
          if (csv === true) {
            if (r.data.meta.count === 0) {
              this.$toastr.info('We don\'t seem to have any internal links here', 'No internal links found')
            } else {
              this.downloadFile('internal-links-' + this.site.domain + '.csv', r.data.data)
            }
          } else {
            this.links = r.data.data
          }
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/InternalLinks.vue